import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';
import { NotProWrapper as OldNotProWrapper } from 'global/NotPro/styled';
import NotPro from 'global/NotPro';

const Wrapper = styled.div`
  align-items: center;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto auto auto;
  padding: 80px 0;
  border-radius: 2px;
  min-height: 316px;
`;

interface INotProProps {
  isFlexible?: boolean;
}

const NotProWrapper = styled.div<INotProProps>`
  height: 330px;
`;

const PaywallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background-color: ${color.light};

  & > img {
    width: 42px;
    height: 42px;
  }
`;

export const PaywallPageWrapper = styled(NotProWrapper)`
  margin: 20px 20px auto 20px;
  max-width: none;
  border: 1px solid ${color.gainsboro};
  border-radius: 2px;
  height: auto;
  max-width: 843px;

  @media ${device.mobileL} {
    margin: 0 auto;
    width: 100%;
  }

  ${({ isFlexible }) =>
    isFlexible &&
    css`
      margin: 20px auto auto -10px;
      width: calc(100% + 20px);
    `}
`;

export const PaywallPage = styled(PaywallWrapper)`
  margin-top: 0px;
  padding: 50px 0;
  width: 100%;
`;

interface IPaywallProps {
  isWidget?: boolean;
}

const TextWrapper = styled.div<IPaywallProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  ${({ isWidget }) =>
    isWidget &&
    css`
      width: 80%;
    `}
`;

const Header = styled(Text)`
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  text-align: center;
  width: 80%;

  @media ${device.mobileL} {
    width: 100%;
  }
`;

const Description = styled(Text)`
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  color: #858585;
  text-align: center;
`;

const ButtonWrapper = styled.div<IPaywallProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  @media ${device.mobileL} {
    flex-direction: row;
    gap: 20px;
  }

  ${({ isWidget }) =>
    isWidget &&
    css`
      flex-direction: column !important;
      gap: 8px !important;
    `}
`;

const ButtonNew = styled(Button).attrs({
  type: 'primary',
})`
  width: 154px;
  height: 28px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: initial;
`;

const ButtonContinue = styled(ButtonNew).attrs({
  type: 'default',
})`
  color: ${color.primary};
  border-color: ${color.primary};

  &:hover,
  &:focus,
  &:active {
    color: ${color.primary};
    border-color: ${color.primary};
  }
`;

interface WidgetWrapperProps {
  height: string;
}

const WidgetWrapper = styled.div<WidgetWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => height};
`;

const CompanyWidgetWrapper = styled.div`
  background-color: ${color.light};
  border: solid 1px ${color.gainsboro};
  margin-bottom: 20px;
  position: relative;

  ${Header} {
    font-size: 13px;
    line-height: 18px;
    width: 80%;
  }

  ${Description} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const CompanyWidgetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: solid 1px ${color.gainsboro};
`;

const CompanyWidgetHeaderTitle = styled(Text).attrs({
  type: 'h5',
})`
  font-size: 14px;
  line-height: 135%;
  font-weight: 700;
`;

const WidgetOrderbookHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #121212;
  border-radius: 3px;
  padding: 0px 6px;

  & > p {
    color: ${color.light};
    font-size: 12px;
    margin: 0;
    padding: 2px 0;
    line-height: initial;
  }
`;

const LastPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: initial;

  & > p {
    color: ${color.dimgray};
    font-size: 12px;
    margin: 0;
  }

  & > span {
    margin-left: 4px;
  }
`;

interface NotProProps {
  isPro?: boolean;
}

export const CustomNotProWrapper = styled(OldNotProWrapper)<NotProProps>`
  margin: 0 auto;
  max-width: none;

  ${({ isPro }) =>
    !isPro &&
    css`
      border: 1px solid ${color.gainsboro};
      border-radius: 2px;
      height: auto;
      max-width: 1000px;
    `}
`;

export const OldNotProContainer = styled(NotPro)`
  margin-top: 0px;
  padding: 50px 0;
  width: 100%;
`;

export {
  Wrapper,
  NotProWrapper,
  PaywallWrapper,
  TextWrapper,
  Header,
  Description,
  ButtonWrapper,
  ButtonNew,
  ButtonContinue,
  WidgetWrapper,
  CompanyWidgetWrapper,
  CompanyWidgetHeader,
  CompanyWidgetHeaderTitle,
  WidgetOrderbookHeader,
  Tag,
  LastPrice,
  OldNotProWrapper,
};
